import axiosPost from "../../axiosPost";
import { respuestaDe } from "../../respuesta";
export const RNHEstablecimientoEstructuraGet = async (credentials, data = {}) => {
  const body = {
    service: "RNHEstablecimientoEstructuraGet",
    params: {
      rnhEstablecimientoEstructuraId: data?.rnhEstablecimientoEstructuraId || null,
      rnhEstablecimientoEstructuraHospitalId: data?.rnhEstablecimientoEstructuraHospitalId || null,
      rnhEstablecimientoEstructuraDepartamentoId: data?.rnhEstablecimientoEstructuraDepartamentoId || null,
      rnhEstablecimientoEstructuraDivisionId: data?.rnhEstablecimientoEstructuraDivisionId || null,
      rnhEstablecimientoEstructuraUnidadId: data?.rnhEstablecimientoEstructuraUnidadId || null,
      rnhEstablecimientoEstructuraURESAId: data?.rnhEstablecimientoEstructuraURESAId || null,
      listAll: data?.listAll ?? null,
      page: data?.page ?? null,
      pageSize: data?.pageSize ?? null,
    },
  };

  return respuestaDe(await axiosPost(body, credentials));
};
